import { NavMarker } from 'react-rhumb';
import LoginForm from './LoginForm';
import UIImage from 'UIComponents/image/UIImage';
import MarketingCta from './MarketingCta';
import { H3 } from 'UIComponents/elements/headings';
import { PercentText } from './MarketingCta.styles';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error not converted to TS
import Image from '../../images/imageUrls.js';
import { MarketingCtaFormWrapper, SplashWrapper, SplashContent, SplashBackground } from './MarketingCta.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLandingSplash = ({
  allowFbSignup,
  signupParams,
  loginRedirectUrl,
  loginSubmit,
  googleLoginClick,
  ssoLoginClick,
  isInvalidTokenAlertVisible,
  pageId
}) => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "LOGIN_LOAD",
    children: [/*#__PURE__*/_jsx(SplashBackground, {}), /*#__PURE__*/_jsxs(SplashWrapper, {
      children: [/*#__PURE__*/_jsxs(SplashContent, {
        centered: true,
        children: [/*#__PURE__*/_jsx(UIImage, {
          src: Image.hubspotLogo,
          width: 200,
          alt: "Hubspot Logo",
          className: "m-bottom-6"
        }), /*#__PURE__*/_jsx(MarketingCtaFormWrapper, {
          children: /*#__PURE__*/_jsx(LoginForm
          // @ts-expect-error ts-migrate - clash between functional and class components
          , {
            onLoginSubmit: loginSubmit,
            onGoogleLoginClick: googleLoginClick,
            onSsoLoginClick: ssoLoginClick,
            isInvalidTokenAlertVisible: isInvalidTokenAlertVisible,
            loginRedirectUrl: loginRedirectUrl,
            variant: "marketing"
          })
        })]
      }), /*#__PURE__*/_jsxs(SplashContent, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "width-100",
          children: /*#__PURE__*/_jsx(PercentText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.marketingCopy.percent"
            })
          })
        }), /*#__PURE__*/_jsx(H3, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.marketingCopy.personalization"
          })
        }), /*#__PURE__*/_jsx(MarketingCta, {
          allowFbSignup: allowFbSignup
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | string[]' is not assignable to type... Remove this comment to see the full error message
          ,
          signupParams: signupParams,
          loginRedirectUrl: loginRedirectUrl,
          pageId: pageId
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.marketingCopy.createAccount"
        }), /*#__PURE__*/_jsx(UIImage, {
          src: Image.loginMarketingImage
        })]
      })]
    })]
  });
};
export default LoginLandingSplash;